import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Trophy } from "lucide-react";

const scopes = [
  { key: "daily", label: "Daily" },
  { key: "weekly", label: "Weekly" },
  { key: "monthly", label: "Monthly" },
  { key: "all", label: "All Time" },
];

export default function Leaderboard() {
  const [scope, setScope] = useState("daily");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/leaderboard/${scope}`).then((r) => setRows(r.data || []))
      .finally(() => setLoading(false));
  }, [scope]);

  const medal = (i) => (i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `#${i + 1}`);

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
      <div className="text-xs font-mono uppercase tracking-widest text-red-500 mb-1">Leaderboard</div>
      <h1 className="font-display text-3xl sm:text-5xl font-black uppercase text-white">Champions</h1>

      <Tabs value={scope} onValueChange={setScope} className="mt-6">
        <TabsList className="bg-slate-900 border border-slate-800">
          {scopes.map((s) => (
            <TabsTrigger key={s.key} value={s.key} data-testid={`lb-tab-${s.key}`}>{s.label}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={scope} className="mt-4">
          <div className="rounded-2xl border border-slate-800 bg-slate-900/70 overflow-hidden" data-testid="leaderboard-table">
            <div className="grid grid-cols-12 px-4 py-3 text-[10px] font-mono uppercase tracking-widest text-slate-500 border-b border-slate-800">
              <div className="col-span-2">Rank</div>
              <div className="col-span-5">Player</div>
              <div className="col-span-2 text-right">Games</div>
              <div className="col-span-3 text-right">Score</div>
            </div>
            {loading ? (
              <div className="p-6 text-slate-400">Loading…</div>
            ) : rows.length === 0 ? (
              <div className="p-6 text-slate-500" data-testid="leaderboard-empty">No scores yet — be the first champion!</div>
            ) : rows.map((r, i) => (
              <div key={r.user_id} data-testid={`lb-row-${i}`}
                className={`grid grid-cols-12 items-center px-4 py-3 border-b border-slate-800/60 ${i < 3 ? "bg-red-950/10" : ""}`}>
                <div className="col-span-2 font-mono text-sm">{medal(i)}</div>
                <div className="col-span-5 font-display font-bold truncate">{r.name}</div>
                <div className="col-span-2 text-right font-mono text-slate-400">{r.games}</div>
                <div className="col-span-3 text-right font-mono text-lg font-black text-red-500 flex items-center justify-end gap-1">
                  <Trophy className="h-4 w-4 opacity-60" /> {r.score.toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
